/* eslint-disable no-unused-vars */
//base class
import React, {Component} from "react";

export default class BaseComponent extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }
}